import { IconNames } from 'ui3/MillionsIcon/MillionsIcon';

export type ShopTab = 'merch' | 'memorabilia' | 'experiences';

export type ShopTabConfig = {
  key: ShopTab;
  label: string;
  icon: IconNames;
};

export type ShopCategories = {
  merch: boolean;
  memorabilia: boolean;
  experiences: boolean;
};

const TAB_PRIORITY: ShopTab[] = ['merch', 'memorabilia', 'experiences'];

export const getShopTabs = (
  availableCategories: ShopCategories
): ShopTabConfig[] => {
  return [
    ...(availableCategories.merch
      ? [
          {
            key: 'merch' as ShopTab,
            label: 'Merch',
            icon: 'shirtOutline' as IconNames,
          },
        ]
      : []),
    ...(availableCategories.memorabilia
      ? [
          {
            key: 'memorabilia' as ShopTab,
            label: 'Memorabilia',
            icon: 'award' as IconNames,
          },
        ]
      : []),
    ...(availableCategories.experiences
      ? [
          {
            key: 'experiences' as ShopTab,
            label: 'Experiences',
            icon: 'book' as IconNames,
          },
        ]
      : []),
  ];
};

/**
 * Returns the first available tab that has results, or the current tab if it has results.
 * Falls back to 'merch' if no tabs have results.
 */
export const getActiveShopTab = (
  availableCategories: ShopCategories,
  currentTab: ShopTab
): ShopTab => {
  // If current tab has results, keep it
  if (availableCategories[currentTab]) {
    return currentTab;
  }

  // Find first tab with results
  const firstAvailable = TAB_PRIORITY.find((tab) => availableCategories[tab]);
  return firstAvailable || 'merch';
};
